import { Inbox, ListFilter, SearchX, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { StateCard } from '@/components/common/StateCard';
import type { StateMessageSize } from '@/components/common/StateMessage';
import type { StatusColorTone } from '@/styles/statusColors';

export type EmptyStateKind = 'noData' | 'noResults' | 'pickFirst';

interface EmptyStateStyle {
  icon: LucideIcon;
  tone: StatusColorTone;
}

const EMPTY_STATE_STYLE: Record<EmptyStateKind, EmptyStateStyle> = {
  noData: { icon: Inbox, tone: 'neutral' },
  noResults: { icon: SearchX, tone: 'neutral' },
  pickFirst: { icon: ListFilter, tone: 'info' },
};

interface EmptyStateProps {
  kind?: EmptyStateKind | undefined;
  icon?: LucideIcon | undefined;
  title: string;
  description?: string | undefined;
  actions?: ReactNode;
  size?: StateMessageSize | undefined;
  fill?: boolean | undefined;
  className?: string | undefined;
}

export function EmptyState({ kind = 'noData', icon, ...card }: EmptyStateProps) {
  const style = EMPTY_STATE_STYLE[kind];
  return <StateCard icon={icon ?? style.icon} tone={style.tone} {...card} />;
}
